import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { SelectorSimpleFactory } from "app/features/selectores/logic";

type Entity = models.FiltroFacturas;
const LimiteFacturas = SelectorSimpleFactory([25, 50, 100, 200, 500, 1000, 2000], x => x, x => "" + x);

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    verSucursalCobranza?: boolean;
    verSelectCliente?: boolean;
}

/**
* Valida un Entity
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {};
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class FiltroComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    private verSucursalCobranza = (props: Props) => props.verSucursalCobranza;

    private verSelectCliente = (props: Props) => props.verSelectCliente;

    private onFechaDesdeChange = (x: Date | null, key: keyof models.FiltroRep) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(0, 0, 0, 0);
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroRep> = { [key]: fecha };
            this.props.onChange({ ...viejo, ...cambioFecha });
        } else {
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroRep> = { [key]: null };
            this.props.onChange({ ...viejo, ...cambioFecha });
        }
    }

    /**
    Establece la hora hasta a la ultima hora del día 11:59 pm
    */
    private onFechaHastaChange = (x: Date | null, key: keyof models.FiltroRep) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(23, 59, 59);
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroRep> = { [key]: fecha };
            this.props.onChange({ ...viejo, ...cambioFecha });
        } else {
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroRep> = { [key]: null };
            this.props.onChange({ ...viejo, ...cambioFecha });
        }
    }

    render() {
        const { value } = this.props;
        const getField = this.getField;
        const verSucursalCobranza = this.verSucursalCobranza(this.props);
        const verSelectCliente = this.verSelectCliente(this.props);

        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        const Cliente = getField(selectores.Cliente);
        const Date = getField(kea.DateTime);
        const Sucursal = getField(selectores.Sucursal);
        const SiNo = getField(selectores.SiNo);
        const EmpresaLogistica = getField(selectores.EmpresaLogistica);
        const Limite = getField(LimiteFacturas);

        return (
            <div>
                {kea.autogrid(2, [
                    <Text field="SerieFolio" />,
                    verSelectCliente ? <Cliente field="IdCliente" label="Cliente" /> : null ,
                    <Date field="FechaInicio" label="Fecha de creación (inicio)" onChange={x => this.onFechaDesdeChange(x, "FechaInicio")} />,
                    <Date field="FechaFinal" label="Fecha de creación (final)" onChange={x => this.onFechaHastaChange(x, "FechaFinal")} />,
                    <Date field="FechaPagoInicio" label="Fecha de pago (inicio)" onChange={x => this.onFechaDesdeChange(x, "FechaPagoInicio")} />,
                    <Date field="FechaPagoFinal" label="Fecha de pago (final)" onChange={x => this.onFechaHastaChange(x, "FechaPagoFinal")} />,
                    <SiNo field="Pagada" label="Pagada" />,
                    <Limite field="Limite" label="Limite" />,
                    verSucursalCobranza ? <Sucursal field="IdSucursalCobranza" label="Sucursal de cobranza" /> : null,
                    <EmpresaLogistica field="EsFacturaLogistica" label="Empresa"  />,

                ])}
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/contrarecibos/list/filtro.tsx